export default function interactiveMap() {
	const container = document.querySelector('.js-imap-container');
	if (! container) return;

	const groups = container.querySelectorAll('.js-imap-group');
	if (! groups) return;
	// console.log(groups);

	const svg = container.querySelector('.js-imap-svg');
	const paths = svg.querySelectorAll('path');
	if (! paths) return;

	let doOnce = true;

	paths.forEach(path => {
		groups.forEach((group, groupIndex) => {
			if (path.dataset.name != group.dataset.name) return;

			group.setAttribute('inert', true);

			// if (doOnce) {
			if (groupIndex == 0) {
				path.classList.add('is-active');
				group.classList.add('is-active');
				group.removeAttribute('inert');
				doOnce = false;
			}

			path.classList.add('imap__map__item');
			path.classList.add('is-interactive');
			// path.setAttribute('tabindex', '0');
			// path.setAttribute('title', group.dataset.label);
			// path.setAttribute('aria-label', group.dataset.label);
			path.addEventListener('click', event => {
				// console.log(`${path.dataset.name} clicked`);
				closeAll();
				path.classList.add('is-active');
				group.classList.add('is-active');
				group.removeAttribute('inert');
				group.scrollIntoView({block: 'center'});
			});
		});
	});

	function closeAll() {
		paths.forEach(path => {
			path.classList.remove('is-active');
		});
		groups.forEach(group => {
			group.classList.remove('is-active');
			group.setAttribute('inert', true);
		});
	}
}
